module.exports = __webpack_public_path__ + "static/media/resume.ac22262e.jpg";